import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1170.000000 593.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
        >
          <path d="M3916 4658 c-3 -24 -10 -90 -17 -148 -55 -510 -271 -1043 -605 -1496
-46 -62 -58 -72 -91 -77 -45 -8 -74 -26 -103 -67 l-21 -30 147 0 147 0 -6 45
c-7 45 -7 45 46 83 143 106 289 196 302 187 7 -6 54 -38 104 -73 55 -38 91
-70 91 -80 0 -35 -13 -62 -32 -68 -20 -6 -58 -59 -58 -81 0 -10 34 -13 136
-13 l135 0 -6 23 c-3 12 -24 39 -46 59 -34 31 -40 42 -37 70 3 28 15 41 98
100 52 37 100 67 106 68 10 0 237 -151 310 -206 31 -24 33 -29 27 -70 l-6 -44
142 0 c77 0 141 3 141 8 0 4 -15 24 -34 44 -32 34 -47 42 -101 50 -47 7 -279
364 -402 618 -56 116 -141 338 -177 463 -39 135 -93 414 -107 550 l-12 127
-33 0 c-31 0 -33 -2 -38 -42z m102 -593 c-2 -18 -9 -30 -18 -30 -10 0 -15 16
-18 63 -5 88 7 111 24 47 8 -27 13 -63 12 -80z m-103 -33 c-3 -3 -12 1 -20 9
-11 11 -12 24 -4 64 17 82 24 84 27 6 2 -40 0 -76 -3 -79z m-5 -67 c0 -6 -13
-19 -30 -28 -29 -18 -30 -18 -30 3 0 12 5 30 10 41 9 16 14 17 30 6 11 -6 20
-17 20 -22z m145 -12 c8 -39 3 -40 -37 -11 l-31 21 23 19 c27 22 35 16 45 -29z
m34 -125 c6 -17 10 -32 9 -33 -54 -37 -98 -65 -102 -65 -3 0 -6 40 -6 89 l0
90 44 -25 c30 -17 48 -35 55 -56z m-173 0 c-2 -40 -5 -79 -5 -86 -1 -10 -53
18 -99 54 -2 1 -1 15 2 31 4 18 20 36 44 50 60 36 63 33 58 -49z m-66 -109
c27 -17 50 -34 50 -39 0 -8 -60 -49 -142 -99 -21 -12 -38 -19 -38 -14 0 9 57
160 66 174 7 13 8 12 64 -22z m297 -41 c17 -40 34 -84 38 -97 l7 -24 -38 22
c-114 67 -143 87 -144 98 0 10 84 70 101 72 3 1 20 -32 36 -71z m-19 -136 c12
-8 22 -18 22 -22 0 -8 -144 -100 -155 -100 -3 0 -5 47 -5 105 l0 106 58 -37
c31 -20 67 -44 80 -52z m-218 -22 c0 -55 -3 -100 -7 -100 -5 1 -41 22 -81 49
-57 37 -70 50 -60 58 27 23 133 92 141 93 4 0 7 -45 7 -100z m-107 -91 c53
-33 97 -65 97 -70 0 -5 -45 -38 -99 -75 l-100 -66 -55 42 c-31 24 -56 44 -56
46 0 18 93 184 103 184 7 0 57 -27 110 -61z m469 -29 c26 -47 48 -88 48 -92 0
-4 -27 -25 -60 -48 l-59 -40 -92 63 c-51 34 -94 68 -96 74 -5 15 176 134 197
130 8 -1 36 -40 62 -87z m-167 -168 c26 -18 45 -38 43 -44 -2 -6 -35 -33 -74
-59 l-69 -48 -8 97 c-4 53 -5 103 -2 110 6 15 19 8 110 -56z m-195 -48 c0 -81
-3 -104 -12 -98 -48 27 -138 97 -138 107 0 13 117 95 138 96 9 1 12 -26 12
-105z m-282 35 c12 -8 22 -18 22 -24 0 -11 -202 -147 -208 -140 -2 2 24 49 59
104 59 96 63 100 83 88 12 -8 31 -20 44 -28z m781 -60 c35 -55 61 -103 58
-105 -7 -7 -206 130 -207 142 0 10 66 62 81 63 3 1 33 -44 68 -100z"/>
<path d="M5480 4151 c-118 -38 -179 -121 -180 -242 0 -51 6 -77 26 -118 77
-154 292 -185 410 -59 62 65 83 142 64 230 -24 115 -110 188 -227 194 -38 2
-79 0 -93 -5z m169 -125 c39 -38 57 -111 41 -163 -51 -160 -257 -141 -277 25
-7 61 21 127 64 155 44 28 134 19 172 -17z"/>
<path d="M7164 4144 c-23 -8 -59 -31 -79 -51 -53 -51 -75 -105 -75 -184 0
-166 138 -280 302 -249 100 19 167 84 193 187 28 108 -13 214 -105 273 -44 28
-62 34 -123 36 -47 3 -86 -2 -113 -12z m173 -104 c43 -26 63 -68 63 -132 0
-98 -64 -163 -153 -155 -54 5 -91 32 -113 84 -31 72 -4 176 54 207 39 22 111
20 149 -4z"/>
<path d="M4820 3906 l0 -246 55 0 55 0 0 85 0 85 38 0 c37 0 39 -2 87 -85 l49
-85 58 0 c32 0 58 4 58 9 0 6 -22 47 -49 92 l-50 82 41 37 c38 34 42 41 45 96
5 68 -14 115 -60 148 -25 19 -46 21 -178 24 l-149 4 0 -246z m258 138 c29 -20
30 -76 2 -104 -16 -16 -33 -20 -85 -20 l-65 0 0 70 0 70 63 0 c40 0 70 -5 85
-16z"/>
<path d="M5910 3905 l0 -245 55 0 55 0 0 168 0 167 35 -55 c19 -30 65 -106
103 -168 l67 -113 65 3 65 3 3 243 2 242 -55 0 -55 0 -2 -167 -3 -168 -100
167 -100 168 -67 0 -68 0 0 -245z"/>
<path d="M6487 4144 c-4 -4 -7 -115 -7 -247 l0 -239 138 4 c150 4 190 17 243
75 48 51 63 92 63 174 1 67 -3 82 -29 125 -19 30 -49 60 -79 79 -48 29 -54 30
-185 33 -75 2 -140 0 -144 -4z m252 -102 c56 -28 76 -64 76 -136 0 -53 -5 -69
-28 -99 -31 -41 -83 -60 -150 -55 l-42 3 -3 140 c-1 76 0 145 2 152 8 19 104
16 145 -5z"/>
<path d="M4863 3473 l-63 -4 0 -32 c0 -32 1 -32 46 -31 86 2 81 13 86 -177 3
-93 7 -172 10 -175 3 -2 23 -6 44 -7 l39 -2 5 180 5 180 50 2 c28 1 53 2 58 2
4 1 7 17 7 36 l0 35 -112 -2 c-62 -1 -141 -3 -175 -5z"/>
<path d="M5383 3472 l-143 -3 0 -209 0 -210 145 0 c80 0 148 -1 153 -2 4 -2 8
14 10 35 l3 38 -98 -1 c-54 -1 -104 -1 -110 -1 -9 1 -13 19 -13 56 l0 55 101
0 100 0 -3 33 -3 32 -98 3 -98 3 3 52 3 52 103 3 102 3 0 29 c0 16 -3 30 -7
32 -5 2 -72 2 -150 0z"/>
<path d="M5664 3463 c-11 -11 -14 -51 -14 -181 0 -92 3 -183 6 -202 l6 -35
134 3 134 3 0 35 0 34 -90 0 -90 0 0 175 c0 133 -3 175 -12 176 -7 0 -24 2
-36 3 -13 2 -30 -4 -38 -11z"/>
<path d="M6030 3263 c0 -164 3 -213 13 -213 6 0 74 -2 150 -3 l138 -2 -3 35
c-3 39 11 35 -155 39 l-53 1 0 55 0 55 95 0 95 0 0 35 0 35 -95 0 -95 0 0 55
0 55 106 0 105 0 -3 33 -3 32 -147 0 -148 0 0 -212z"/>
<path d="M6542 3461 c-82 -39 -124 -108 -124 -203 1 -91 41 -153 129 -197 78
-39 194 -20 250 41 l23 24 -32 24 c-20 15 -35 20 -43 14 -55 -41 -70 -47 -108
-46 -50 2 -86 26 -109 73 -62 120 48 254 168 204 21 -8 41 -21 45 -27 7 -10
69 28 69 43 0 3 -18 19 -40 34 -55 38 -164 46 -228 16z"/>
<path d="M7004 3455 c-133 -67 -158 -255 -47 -356 83 -76 231 -77 309 -1 50
48 68 93 68 167 0 63 -3 75 -29 110 -38 51 -51 62 -100 85 -58 28 -139 26
-201 -5z m160 -59 c74 -31 105 -121 67 -198 -50 -105 -182 -109 -233 -7 -24
45 -23 93 3 147 32 65 93 87 163 58z"/>
<path d="M7440 3263 l0 -213 45 0 44 0 3 143 c3 122 5 138 15 114 7 -15 21
-46 31 -70 11 -23 32 -75 47 -114 22 -60 31 -73 48 -73 18 0 28 16 56 88 56
144 73 182 82 182 5 0 9 -60 9 -134 0 -131 0 -134 23 -138 58 -10 57 -16 57
218 l0 214 -52 -4 c-29 -3 -56 -5 -59 -5 -7 -1 -35 -68 -80 -186 -38 -99 -33
-103 -108 95 l-36 95 -63 0 -62 0 0 -212z"/>
<path d="M5006 2824 c-8 -20 -8 -63 0 -102 6 -29 9 -30 60 -34 38 -2 54 1 54
10 0 7 -15 12 -40 12 -33 0 -40 3 -40 20 0 16 7 20 35 20 24 0 35 5 35 15 0
10 -11 15 -35 15 -24 0 -35 5 -35 15 0 11 11 15 40 15 29 0 40 4 40 15 0 22
-105 21 -114 -1z"/>
<path d="M5320 2765 c0 -60 3 -75 15 -75 11 0 15 12 15 48 l1 47 22 -30 c35
-48 66 -77 77 -70 6 3 10 40 10 81 0 59 -3 74 -15 74 -11 0 -15 -12 -15 -45 0
-25 -3 -45 -7 -45 -5 1 -23 21 -41 45 -49 67 -62 61 -62 -30z"/>
<path d="M5650 2823 c0 -9 3 -13 6 -10 4 3 14 2 24 -3 14 -7 16 -19 13 -57 -2
-26 0 -54 5 -62 18 -26 32 0 32 60 0 52 2 59 20 59 11 0 20 7 20 15 0 12 -13
15 -60 15 -49 0 -60 -3 -60 -17z"/>
<path d="M5967 2833 c-9 -8 -9 -90 -1 -120 6 -20 13 -23 60 -23 30 0 54 5 54
10 0 6 -18 10 -40 10 -33 0 -40 3 -40 20 0 16 7 20 35 20 24 0 35 5 35 15 0
10 -11 15 -35 15 -49 0 -48 28 2 32 61 5 53 28 -9 28 -30 0 -58 -3 -61 -7z"/>
<path d="M6280 2765 c0 -60 3 -75 15 -75 9 0 15 9 15 25 0 32 23 33 38 1 5
-13 20 -26 31 -29 25 -6 25 -6 9 28 -9 19 -9 28 0 37 7 7 12 24 12 40 0 33
-24 48 -79 48 l-41 0 0 -75z m90 25 c0 -18 -19 -30 -46 -30 -13 0 -20 40 -9
52 12 12 55 -5 55 -22z"/>
<path d="M6600 2759 c0 -59 3 -80 12 -77 7 3 15 15 18 29 5 18 14 25 44 30 92
15 66 99 -31 99 l-43 0 0 -81z m88 27 c-4 -26 -45 -35 -54 -12 -11 28 2 44 31
38 20 -3 25 -10 23 -26z"/>
<path d="M6920 2765 c0 -60 3 -75 15 -75 8 0 15 9 15 19 0 33 22 36 42 8 11
-15 26 -27 34 -27 17 0 17 5 4 31 -8 15 -7 23 5 35 37 37 -2 84 -70 84 l-45 0
0 -75z m90 25 c0 -17 -36 -34 -52 -24 -13 8 -9 42 5 47 22 7 47 -5 47 -23z"/>
<path d="M7248 2833 c-8 -14 -10 -102 -3 -123 3 -11 13 -20 21 -20 12 0 14 14
12 72 -2 43 -8 73 -15 75 -6 2 -13 0 -15 -4z"/>
<path d="M7486 2824 c-9 -8 -16 -22 -16 -29 0 -17 38 -45 62 -45 22 0 33 -19
19 -33 -8 -8 -19 -8 -41 0 -20 8 -32 8 -36 1 -10 -16 18 -28 60 -26 71 5 76
62 7 82 -44 13 -39 42 7 38 33 -4 44 11 16 22 -28 11 -62 6 -78 -10z"/>
<path d="M7787 2833 c-9 -8 -9 -71 -1 -112 6 -30 8 -31 60 -31 30 0 54 5 54
10 0 6 -18 10 -40 10 -33 0 -40 3 -40 20 0 16 7 20 35 20 24 0 35 5 35 15 0
10 -11 15 -35 15 -49 0 -48 28 2 32 61 5 53 28 -9 28 -30 0 -58 -3 -61 -7z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
